import actionTypes from '../constants/action-types';

const loadTranslations = (locale) => ({
  type: actionTypes.LOAD_TRANSLATIONS,
  payload: { locale },
});

export default loadTranslations;
